<template>
  <v-container v-if="till">
    <v-row justify="space-between" no-gutters class="mb-2">
      <v-btn exact text :to="{ name: 'TillIndex' }">
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
    </v-row>
    <v-row dense no-gutters align="center" justify="end" v-if="till">
      <span class="caption"
        >Dernière correction le {{ till.updated | localFormat }}</span
      >
    </v-row>
    <v-card>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Début"
              readonly
              filled
              class="no-before"
              hide-details
              dense
              :value="till.display_start_date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Fin"
              readonly
              filled
              class="no-before"
              hide-details
              dense
              :value="till.display_end_date"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12" sm="4">
            <v-text-field
              label="Effectué par"
              readonly
              filled
              class="no-before"
              hide-details
              dense
              :value="till.signataire"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Écart"
              readonly
              filled
              class="no-before"
              hide-details
              dense
              suffix="$"
              :value="till.ecart_caisse"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Dépôt"
              readonly
              filled
              class="no-before"
              hide-details
              dense
              suffix="$"
              :value="till.deposit ? till.deposit.value : 0"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-card-text>
        <TillPayments v-bind="till.payments" read-only></TillPayments>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-card-text>
        <TillTips v-bind="till.tips" read-only></TillTips>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-card-text>
        <TillCaisse
          v-bind="till.tiroir_caisse"
          read-only
          show-total
        ></TillCaisse>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { api } from "@/api";
import moment from "moment";
import { TillCaisse, TillPayments, TillTips } from "../components";
export default {
  name: "TillEditor",
  components: {
    TillCaisse,
    TillPayments,
    TillTips
  },
  props: {
    id: {
      required: true
    }
  },
  mounted() {
    this.getData();
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getData();
    });
  },
  async beforeRouteUpdate() {
    await this.getData();
  },
  data() {
    return {
      loading: true,
      till: undefined
    };
  },
  methods: {
    async getData() {
      if (this.id) {
        try {
          this.$store.dispatch("slo");
          this.loading = true;
          this.till = await api.retrieveTill(this.id);
          this.till.display_start_date = moment(this.till.start_date).format(
            "ll"
          );
          this.till.display_end_date = moment(this.till.end_date).format("ll");
        } finally {
          this.loading = false;
          this.$store.dispatch("elo");
        }
      }
    }
  }
};
</script>

<style></style>
